import { render, staticRenderFns } from "./BusTypeCreate.vue?vue&type=template&id=09664cd2&scoped=true"
import script from "./bus_type_create.js?vue&type=script&lang=js&external"
export * from "./bus_type_create.js?vue&type=script&lang=js&external"
import style0 from "./BusTypeCreate.vue?vue&type=style&index=0&id=09664cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09664cd2",
  null
  
)

export default component.exports